import { ListingType } from '../../../modules/storefront/listingCardCreation/types'

export const getIntegrationTypeLabel = (type?: string | null) =>
  type === ListingType.BUTTON ? 'button' : 'listing card'
